"use client";

import { useEffect, useState } from "react";

import {
  isAnonAnalyticsOff,
  setAnonAnalyticsOff,
} from "@/lib/posthog/anonymous-analytics";

/* The always-available way to object to anonymous analytics (see
   anonymous-analytics.ts). PostHog reads the setting at init, so a change
   reloads the page to take effect. Renders nothing until mounted: the
   setting lives in the browser and the footer is server-rendered. */
export default function AnonAnalyticsToggle({ className }: { className?: string }) {
  const [off, setOff] = useState<boolean | null>(null);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setOff(isAnonAnalyticsOff());
  }, []);

  if (off === null) return null;

  return (
    <button
      type="button"
      className={className}
      aria-pressed={!off}
      onClick={() => {
        setAnonAnalyticsOff(!off);
        window.location.reload();
      }}
    >
      {off ? "Anonymous analytics: off" : "Anonymous analytics: on"}
    </button>
  );
}
